import { render, staticRenderFns } from "./NotToday.vue?vue&type=template&id=3c27ba52&"
import script from "./NotToday.vue?vue&type=script&lang=js&"
export * from "./NotToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports